import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    getLengt_arraybk,
} from '../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../pages/Master_Front_Buyer";


import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";


import '../../assets/cssnew/request-reg.css'


import serialize from "form-serialize";

import {Iconbk_verify_panel} from  "../../assets/icones/icones"


const My_Dashboard = (props) => {

    const location = useLocation()


    const location_get_urlbk = useLocation();

    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');

    const [data_full, setData_full] = useState([]);

    /*  end profile */

    const [active_tab_curent, set_active_tab_curent] = useState("tab1")

    const [cat_list_full, setData_cat_list_full] = useState([]);



    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {

        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };


        Setloadinghkfullshow("true");


        let form_data = document.querySelector('#form_data');
        if (form_data != null) {

            let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get/`, data_serialize, config)


                .then((res) => {
                    Setloadinghkfullshow("false");
///console.log(res.data);
                    if (String(res.data).length > 0) {

                        if (String(res.data.data) == "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }


                        if (!empty_bk(res.data.type_user)) { setData_type_user_panel(res.data.type_user); }

                        setData_full(res.data);

                        if (String(res.data.wallet_inventory).length > 0) {
                            setData_wallet_balance(res.data.wallet_inventory);
                        }
                        if (!empty_bk(res.data.first_name_profile)) {
                            setData_first_name_profile(res.data.first_name_profile);

                            localStorage.setItem('first_name_Get', res.data.first_name_profile);
                        }
                        if (!empty_bk(res.data.last_name_profile)) {
                            setData_last_name_profile(res.data.last_name_profile);
                            localStorage.setItem('last_name_Get', res.data.last_name_profile);
                        }
                        if (!empty_bk(res.data.profile_src)) {
                            setData_profile_src(res.data.profile_src);
                        }




                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطا اتصال به سرور کد  435346', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });


        }


    }





    return (<Fragment>


<style jsx>{`
    

.box-content-panelbk{
min-height: 100vh;
}

.container-panel-bk {
margin-right: 3%;
margin-left: 3%;
}






`}</style>


            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance}
                                first_name_profile={first_name_profile}
                                last_name_profile={last_name_profile} profile_src={profile_src}
                                status_authentication={`${data_full && data_full.status_authentication!="approved" ? data_full.status_authentication  :''}`}
            >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>


                <div className={"box-content-panelbk"}>

                    <span className={"title-box-content-panel"}>پیشخوان</span>

                    <form id={"form_data"} name={"form_data"} encType="multipart/form-data" style={{width: "100%"}}>


                        <div className={"container-panel-bk"}>

                            <div className={"flex flex-col items-start lg:flex-row justify-between lg:items-center px-[24px] py-[16px] gap-[16px] w-full h-auto bg-[#F3F4F6] rounded-[16px] mt-[14px]"}>

                                <div style={{"display":"flex","flexDirection":"row","justifyContent":"center","alignItems":"center"}}>
                                    <img src={profile_src} alt={"profile"}  className={"w-[75px] rounded-[100%] p-[4px] border-[solid] border-[3px] border-[#9CA3AF]"} />
                                    <div style={{"display":"flex","flexDirection":"column","flexWrap":"wrap","alignContent":"center","justifyContent":"center","alignItems":"flex-start","paddingRight":"13px"}}>
                                        <span className={"text-[black] text-[15px] lg:text-[20px] font-[iran] font-semibold"} >{first_name_profile} {last_name_profile}</span>
                                        <span className={"text-[rgb(107,_114,_128)]   text-[15px] font-[iran]"} >استان خراسان رضوی- شهر مشهد</span>
                                    </div>
                                </div>


                                <div>
                                    <NavLink className={"text-[rgb(255,_152,_40)] flex flex-row justify-center items-center"} reloadDocument={true} to={"/panel/profile"}>
                                        ویرایش پروفایل
                                        <svg style={{"marginRight":"15px","display":"block"}} width={8} height={12} viewBox="0 0 8 12" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.41 10.59L2.83 6L7.41 1.41L6 0L0 6L6 12L7.41 10.59Z"
                                                  fill="#FF9828"/>
                                        </svg>
                                    </NavLink>
                                </div>
                            </div>





                            {
                                data_full && data_full.status_authentication!="approved" && (
                                    <div
                                        className={"flex flex-col items-start lg:flex-row justify-between lg:items-center px-[24px] py-[16px] gap-[16px] w-full h-auto bg-[white] rounded-[16px] mt-[14px]"}
                                        style={{border: "solid", borderWidth: "1px", borderColor: "#e8eaed"}}>

                                        <div style={{
                                            "display": "flex",
                                            "flexDirection": "row",
                                            "justifyContent": "center",
                                            "alignItems": "center"
                                        }}>
                                            <svg width={24} height={25} viewBox="0 0 24 25" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <g clipPath="url(#clip0_0_2926)">
                                                    <path
                                                        d="M23 12.5L20.56 9.71L20.9 6.02L17.29 5.2L15.4 2L12 3.46L8.6 2L6.71 5.19L3.1 6L3.44 9.7L1 12.5L3.44 15.29L3.1 18.99L6.71 19.81L8.6 23L12 21.53L15.4 22.99L17.29 19.8L20.9 18.98L20.56 15.29L23 12.5ZM10.09 17.22L6.29 13.41L7.77 11.93L10.09 14.26L15.94 8.39L17.42 9.87L10.09 17.22Z"
                                                        fill="#01A3D4"/>
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_0_2926">
                                                        <rect width={24} height={24} fill="white"
                                                              transform="translate(0 0.5)"/>
                                                    </clipPath>
                                                </defs>
                                            </svg>

                                            <div style={{
                                                "display": "flex",
                                                "flexDirection": "column",
                                                "flexWrap": "wrap",
                                                "alignContent": "center",
                                                "justifyContent": "center",
                                                "alignItems": "flex-start",
                                                "paddingRight": "13px"
                                            }}>
                                        <span
                                            className={"text-[black] text-[15px] lg:text-[20px] font-[iran] font-semibold"}>هویت حساب کاربری خود را احراز کنید</span>
                                                <span className={"text-[rgb(107,_114,_128)]   text-[15px] font-[iran]"}>با تایید هویت خود، برای فروشندگان، خریدار مطمئن تری باشید.</span>
                                            </div>
                                        </div>


                                        <div>
                                            <NavLink
                                                className={"text-[white] flex flex-row justify-center items-center bg-[#01A3D4] text-[13px] py-[5px] px-[19px] rounded-[6px]"}
                                                reloadDocument={true} to={"/panel/authentication"}>
                                                <Iconbk_verify_panel className={"pl-[5px]"} width={26} height={26}/>
                                                احراز هویت
                                            </NavLink>
                                        </div>
                                    </div>
                                )

                            }


                        </div>


                    </form>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default My_Dashboard;